import React, { useEffect } from "react";
import { useConnectWallet } from "../../hooks/useConnectWallet";
import { useCurrentAccountState } from "../../state/hooks";
import useBreakpoint from "use-breakpoint";
import styled from "styled-components";
import { Helmet } from "react-helmet-async";
import { Button } from "@mui/material";
import logoMetamask from "../../assets/logo/logo-metamask.png";

const BREAKPOINTS = { mobile: 0, tablet: 768, desktop: 1280 };

const Layout = styled.div<{ breakpoint: string }>`
  margin: ${({ breakpoint }) =>
    breakpoint === "desktop" ? "0px 120px" : "0px 20px"};
  min-height: 76vh;
  display: grid;
  justify-content: center;
  align-items: center;
`;

const Rows = styled.div`
  margin: 30px auto;
  width: 100%;
  grid-template-columns: repeat(auto-fill, minmax(400px, 2fr));
  display: grid;
  justify-content: center;
  align-content: center;
  grid-auto-rows: 200px;
  grid-gap: 0.5em;
  justify-items: center;
`;

const CustomButton = styled(Button)`
  &.MuiButton-root {
    background: #35393d;
    border-radius: 10px;
    font-size: 2rem;
    font-family: Montserrat;
    color: #fff;
    cursor: pointer;
    width: 100%;
    text-transform: capitalize;

    &:hover {
      background: #35393d;
      opacity: 0.8;
    }
  }
`;

const Wallet: React.FC = () => {
  const { breakpoint } = useBreakpoint(BREAKPOINTS, "mobile");
  const { onConnect } = useConnectWallet();

  const handleConnectWallet = () => {
    onConnect();
  };

  const account = useCurrentAccountState();
  const handleRoute = () => {
    window.location.href = `/verify${location.search}`;
  };
  useEffect(() => {
    if (account) {
      handleRoute();
    }
  }, [account]);

  const walletList = [
    {
      name: "Metamask",
      logo: logoMetamask,
    },
    // {
    //   name: "Kaikas",
    //   logo: logoKaikas,
    // },
    // {
    //   name: "WalletConnect",
    //   logo: logoWalletConnect,
    // },
  ];

  return (
    <>
      <Helmet>
        <title>Home - SIX ZONE</title>
      </Helmet>
      <Layout breakpoint={breakpoint}>
        <Rows>
          {walletList.map((v, i) => (
            <CustomButton
              href={account && `/verify${location.search}`}
              onClick={handleConnectWallet}
              key={i}
            >
              <img src={v.logo} alt="logoMetamask" width={60} />
              &nbsp; {v.name}
            </CustomButton>
          ))}
        </Rows>
      </Layout>
    </>
  );
};

export default Wallet;
